// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"77722fa6","186":"ab5d3e79","348":"43c7315a","637":"67385ee5"}[chunkId] + ".chunk.js";
};